import { Injectable } from '@angular/core';
import { HttpService } from '@services/http.service';
import {
    ChangeStatusNotification,
    CountNotifyItemResponse,
    NotificationInteractReq,
    NotificationModel,
    NotificationSearchParam,
} from '@models/notification.model';
import { BaseResponse } from '@models/common.model';
import { map, Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private readonly _http: HttpService) {}

    /**
     * Search notification by user
     *
     * @param {NotificationSearchParam} params
     * @return {*}  {Observable<BaseResponse<NotificationModel[]>>}
     * @memberof NotificationService
     */
    public searchNotificationByUser(
        params: NotificationSearchParam
    ): Observable<BaseResponse<NotificationModel[]>> {
        return this._http.get('Notify/SearchByUser', {
            params: new HttpParams({ fromObject: { ...params } }),
            showProgress: false,
        });
    }

    /**
     * Count notification unread
     *
     * @param {Pick<NotificationSearchParam, 'user_id'>} params
     * @return {*}  {Observable<CountNotifyItemResponse>}
     * @memberof NotificationService
     */
    public countNotificationUnRead(): Observable<CountNotifyItemResponse> {
        return this._http
            .get<BaseResponse<CountNotifyItemResponse>>('Notify/CountUnReadByUser', {
                showProgress: false,
            })
            .pipe(map((res) => res.Data || { TotalItemUnRead: 0 }));
    }

    /**
     * Change status notification
     *
     * @param {ChangeStatusNotification} reqBody
     * @return {*}  {Observable<BaseResponse>}
     * @memberof NotificationService
     */
    public changeStatusNotification(reqBody: ChangeStatusNotification): Observable<BaseResponse> {
        return this._http.post('Notify/ChangeStatus', reqBody);
    }

    /**
     * Interact notification
     *
     * @param {NotificationInteractReq} reqBody
     * @return {*}  {Observable<BaseResponse>}
     * @memberof NotificationService
     */
    public interactNotification(reqBody: NotificationInteractReq): Observable<BaseResponse> {
        return this._http.post('Notify/'.concat(reqBody.Action), reqBody);
    }
}
